import EncryptUtility from "../../utility/js/encrypt-utility";

export default {
  // Validate query parameters before entering route
  beforeRouteEnter(to, from, next) {
    const encodedEmail = to.query.ue;
    const resetKey = to.query.rk;
    
    // Redirect to unauthorized if parameters are missing
    if (!encodedEmail || !resetKey) {
      next("/unauthorized");
    } else {
      next();
    }
  },

  data() {
    return {
      logoImg: require("@/assets/images/RLP.png"),
      userEmail: "",
      newPassword: "",
      confirmPassword: "",
      isPasswordShow: false,
      isConfirmPasswordShow: false,
      resetKey: "",
      isValidLink: false,
      passwordRules: [
        (v) => !!v || "Password is required",
        (v) => (v && v.length >= 8) || "Password must be at least 8 characters",
        (v) => /[A-Z]/.test(v) || "Password must contain at least one uppercase letter",
        (v) => /[a-z]/.test(v) || "Password must contain at least one lowercase letter",
        (v) => /[0-9]/.test(v) || "Password must contain at least one number",
        (v) => /[!@#$%^&*(),.?":{}|<>]/.test(v) || "Password must contain at least one special character",
      ],
      confirmPasswordRules: [
        (v) => !!v || "Please confirm your password",
        (v) => v === this.newPassword || "Passwords do not match",
      ],
      rlpTheme: {
        primary: "#005ba8",
        secondary: "#f89554",
        menubreadcrums: "#FFFFFF",
        containerbox: "#FFFFFF",
        primarytext: "#005ba8",
        navlinks: "#005ba8",
        activeColor: "#2ed8b6",
        inactiveColor: "#ff5370",
        background: "#f4f5fa",
        tertiary: "#e9e7f7",
        customwhite: "#FFFFFF",
        accent: "#82B1FF",
        error: "#FF5252",
        info: "#2196F3",
        success: "#4CAF50",
        warning: "#FFC107",
        customLightGrey: "#EBEEF3",
        cWhite: "#FFFFFF",
        red: "#DC143C",
      },
    };
  },
  mounted() {
    // Set theme
    this.$vuetify.theme.dark = false;
    this.$vuetify.theme.themes["light"] = this.rlpTheme;
    
    // Hide navigation
    EncryptUtility.localStorageEncrypt("showNav", false.toString());
    this.$store.commit("ConfigModule/showNav", false);

    // Extract and validate query parameters
    this.extractQueryParams();
    
    // Validate reset link on page load 
    if (this.isValidLink) {
      this.validateResetLink();
    }
    
    // Prevent bookmarking by clearing URL params after extraction
    this.clearUrlParams();
  },
  methods: {
    // Extract query parameters from URL
    extractQueryParams() {
      const urlParams = new URLSearchParams(window.location.search);
      const encodedEmail = urlParams.get("ue");
      const resetKey = urlParams.get("rk");

      // Validate required parameters (should always be present due to route guard)
      if (!encodedEmail || !resetKey) {
        this.isValidLink = false;
        return;
      }

      // Decode email and store values
      try {
        this.userEmail = decodeURIComponent(encodedEmail);
        this.resetKey = resetKey;
        this.isValidLink = true;
      } catch (error) {
        // If decoding fails, mark as invalid
        this.isValidLink = false;
        console.error("Failed to decode email parameter:", error);
      }
    },

    // Clear URL parameters to prevent bookmarking
    clearUrlParams() {
      // Use replaceState to remove query parameters from URL without reloading
      if (window.history && window.history.replaceState) {
        const cleanUrl = window.location.protocol + "//" + window.location.host + window.location.pathname;
        window.history.replaceState({ path: cleanUrl }, "", cleanUrl);
      }
    },

    // Validate reset link on page load (pass = 3)
    validateResetLink() {
      let LoaderDialog = {
        visible: true,
        title: "Validating reset link...",
      };
      this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);

      // Prepare API request with pass = 3
      let validateModel = {
        user_email: this.userEmail,
        captcha: "",
        pass: 3,
        pass_reset_key: this.resetKey,
      };

      // Call API to validate the reset link
      this.axios
        .post("ap/forgot-password", validateModel)
        .then((response) => {
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);

          if (response.status == 200 || response.status == 204) {
            // Link is valid, allow password reset
            this.isValidLink = true;
          } else {
            // Link validation failed
            this.isValidLink = false;
            let Alert = {
              type: "error",
              isShow: true,
              message: "Invalid or expired password reset link. Please request a new one.",
            };
            this.$store.commit("ConfigModule/Alert", Alert);
            
            setTimeout(() => {
              this.$router.push("/login");
            }, 3000);
          }
        })
        .catch((error) => {
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);

          // Handle error
          let errorMessage = "Unable to validate reset link. Please try again or request a new one.";

          if (error.response && error.response.data && error.response.data.message) {
            errorMessage = error.response.data.message;
          } else if (error.message) {
            errorMessage = error.message;
          }

          this.isValidLink = false;
          let Alert = {
            type: "error",
            isShow: true,
            message: errorMessage,
          };
          this.$store.commit("ConfigModule/Alert", Alert);

          // Redirect to login after error
          setTimeout(() => {
            this.$router.push("/login");
          }, 3000);
        });
    },

    // Show/Hide password
    showPassword() {
      this.isPasswordShow = !this.isPasswordShow;
    },

    // Show/Hide confirm password
    showConfirmPassword() {
      this.isConfirmPasswordShow = !this.isConfirmPasswordShow;
    },

    // Reset password
    resetPassword() {
      // Validate form
      if (!this.$refs.resetPasswordForm.validate()) {
        return false;
      }

      // Check if link is valid
      if (!this.isValidLink) {
        let Alert = {
          type: "error",
          isShow: true,
          message: "Invalid password reset link. Please request a new one.",
        };
        this.$store.commit("ConfigModule/Alert", Alert);
        return false;
      }

      // Check if passwords match
      if (this.newPassword !== this.confirmPassword) {
        let Alert = {
          type: "error",
          isShow: true,
          message: "Passwords do not match. Please try again.",
        };
        this.$store.commit("ConfigModule/Alert", Alert);
        return false;
      }

      let LoaderDialog = {
        visible: true,
        title: "Resetting Password...",
      };
      this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);

      // Encrypt the password
      // var encryptedPassword = EncryptUtility.passwordEncrypt(this.newPassword);

      // Prepare API request
      let resetPasswordModel = {
        user_email: this.userEmail,
        captcha: "", // Not required for pass 4
        pass: 4,
        new_password: this.newPassword,
        pass_reset_key: this.resetKey,
      };

      // Call API
      this.axios
        .post("ap/forgot-password", resetPasswordModel)
        .then((response) => {
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);

          if (response.status == 200 || response.status == 204) {
            // Success - show success message and redirect to login
            let Alert = {
              type: "success",
              isShow: true,
              message: "Password has been reset successfully. Please login with your new password.",
            };
            this.$store.commit("ConfigModule/Alert", Alert);

            // Clear form
            this.newPassword = "";
            this.confirmPassword = "";
            this.resetKey = "";
            this.isValidLink = false;

            // Redirect to login page after 3 seconds
            setTimeout(() => {
              this.$router.push("/login");
            }, 3000);
          } else {
            // Unexpected response
            let Alert = {
              type: "error",
              isShow: true,
              message: "Unable to reset password. Please try again or contact support.",
            };
            this.$store.commit("ConfigModule/Alert", Alert);
          }
        })
        .catch((error) => {
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);

          // Handle error
          let errorMessage = "An error occurred while resetting password. Please try again.";

          if (error.response && error.response.data && error.response.data.message) {
            errorMessage = error.response.data.message;
          } else if (error.message) {
            errorMessage = error.message;
          }

          let Alert = {
            type: "error",
            isShow: true,
            message: errorMessage,
          };
          this.$store.commit("ConfigModule/Alert", Alert);

          // If the reset key is invalid or expired, redirect to login
          if (errorMessage.toLowerCase().includes("expired") || errorMessage.toLowerCase().includes("invalid")) {
            setTimeout(() => {
              this.$router.push("/login");
            }, 3000);
          }
        });
    },

    // Navigate back to login
    backToLogin() {
      this.$router.push("/login");
    },
  },

  // Prevent navigation away from page if password reset is in progress
  beforeRouteLeave(to, from, next) {
    // If form has values, confirm before leaving
    if (this.newPassword || this.confirmPassword) {
      const answer = window.confirm("Are you sure you want to leave? Your password reset will not be saved.");
      if (answer) {
        next();
      } else {
        next(false);
      }
    } else {
      next();
    }
  },
};
